// /terms — generic draft. Needs legal review before anyone signs
// anything binding against it. Covers the common cases.
import { useSeo } from "@/hooks";
import { MarketingShell } from "./MarketingShell";

export function TermsPage() {
  useSeo({
    title: "Terms — malbox",
    description: "Rules of the sandbox: what you can do, what you can't, and the no-warranty boilerplate for the hosted beta.",
    path: "/terms",
  });
  return (
    <MarketingShell
      eyebrow="Terms of service"
      title="Rules of the sandbox."
      lede={<>Short version: don't attack us, don't attack others through us, don't submit anything you don't have the right to analyze.</>}
    >
      <div className="max-w-[720px] space-y-8 text-ui text-ink-soft">
        <section>
          <h2 className="font-mono text-ink" style={{ fontSize: "20px", letterSpacing: "-0.015em" }}>What you can do</h2>
          <p className="mt-3">
            Submit samples for analysis via the hosted service, free during beta, subject to the limits on the <a className="text-ink underline" href="/docs#limits">Docs page</a>. Self-hosted and private deployments are in early access — contact <a className="text-ink underline" href="mailto:neel@neels.dev">neel@neels.dev</a>.
          </p>
        </section>
        <section>
          <h2 className="font-mono text-ink" style={{ fontSize: "20px", letterSpacing: "-0.015em" }}>What you can't do</h2>
          <ul className="mt-3 list-inside list-disc space-y-1 pl-2">
            <li>Use the sandbox to launch attacks against third parties</li>
            <li>Submit content you don't have the legal right to analyze (customer data without authorization, PII without basis)</li>
            <li>Attempt to escape the guest, interfere with other submissions, or exfiltrate data belonging to others</li>
            <li>Scrape at a rate that disrupts the service for other users</li>
            <li>Re-sell hosted-service access</li>
          </ul>
        </section>
        <section>
          <h2 className="font-mono text-ink" style={{ fontSize: "20px", letterSpacing: "-0.015em" }}>No warranty</h2>
          <p className="mt-3">
            The hosted service is provided as-is during beta, with no uptime guarantee and no warranty of fitness for a particular purpose. Analysis output is best-effort — it's a tool to help human analysts, not a decision engine.
          </p>
        </section>
        <section>
          <h2 className="font-mono text-ink" style={{ fontSize: "20px", letterSpacing: "-0.015em" }}>Account suspension</h2>
          <p className="mt-3">
            We may suspend an account that violates these terms, with notice when possible. Submissions associated with the account are preserved for audit even if the account is removed.
          </p>
        </section>
        <section>
          <h2 className="font-mono text-ink" style={{ fontSize: "20px", letterSpacing: "-0.015em" }}>License</h2>
          <p className="mt-3">
            Source availability and the self-hosted licensing model are being finalized ahead of the public release. Early-access deployments are negotiated per use case — email <a className="text-ink underline" href="mailto:neel@neels.dev">neel@neels.dev</a> for details. The malbox name and marks are reserved.
          </p>
        </section>
        <section>
          <h2 className="font-mono text-ink" style={{ fontSize: "20px", letterSpacing: "-0.015em" }}>Changes</h2>
          <p className="mt-3">
            Material changes will be noted in the <a className="text-ink underline" href="/changelog">changelog</a>.
          </p>
        </section>
        <p className="pt-6 meta tabular-nums">Last updated 2026-10-24.</p>
      </div>
    </MarketingShell>
  );
}
